import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { EffortListItem, GroupedEfforts } from 'types/efforts';
import EffortGroup from './EffortGroup';

type Props = {
    efforts: EffortListItem[];
};

const groupEffortsByDate = (efforts: EffortListItem[]): Map<string, GroupedEfforts> => {
    const groupedEfforts: Map<string, GroupedEfforts> = new Map();

    efforts.forEach((effort) => {
        const group = groupedEfforts.get(effort.effortDate);
        if (group) {
            group.usedTimeInSeconds += effort.usedTimeInSeconds;
            group.efforts.push(effort);
        } else {
            groupedEfforts.set(effort.effortDate, {
                usedTimeInSeconds: effort.usedTimeInSeconds,
                efforts: [effort],
            });
        }
    });

    return groupedEfforts;
};

const EffortList: FC<Props> = ({ efforts }) => {
    if (efforts.length === 0) {
        return (
            <div className="m-[14px] flex justify-center">
                <p className="text-body1">
                    <FormattedMessage id="efforts.no-efforts-found" />
                </p>
            </div>
        );
    }

    const groupedEfforts = groupEffortsByDate(efforts);

    return (
        <div className="flex h-full flex-col">
            {Array.from(groupedEfforts).map(([date, group]) => (
                <EffortGroup key={date} date={date} effortGroup={group} />
            ))}
        </div>
    );
};

export default EffortList;
